/*
 * @Author: hzm
 * @Date: 2022-12-14 14:13:46
 * @Description:
 */
/*
 * @Author: hzm
 * @Date: 2022-07-14 12:47:18
 * @Description:
 */
import http from '@/utils/request';

// 查询待办任务列表
export function listTask(query: ObjType) {
  return http.request<API.TodoTask>({
    url: '/system/wk/task/list',
    method: 'get',
    params: query,
  });
}

// 查询待办任务详细
export function getTask(id: Ids) {
  return http.request<API.TodoTask>({
    url: '/system/wk/task/' + id,
    method: 'get',
  });
}

// 新增待办任务
export function addTask(data: ObjType) {
  return http.request<API.TodoTask>({
    url: '/system/wk/task',
    method: 'post',
    data: data,
  });
}

// 修改待办任务
export function updateTask(data: ObjType) {
  return http.request<API.TodoTask>({
    url: '/system/wk/task',
    method: 'put',
    data: data,
  });
}

// 删除待办任务
export function delTask(id: Ids) {
  return http.request<API.TodoTask>({
    url: '/system/wk/task/' + id,
    method: 'delete',
  });
}
/**
 * 根据模板创建任务
 * @param data
 * @returns
 */
export function createByTemplate(data: ObjType) {
  return http.request<API.TodoTask>({
    url: '/system/wk/task/createByTemplate',
    method: 'post',
    data: data,
  });
}

export function listTaskForUser(query: ObjType) {
  return http.request<API.TodoTask>({
    url: '/system/wk/task/listForUser',
    method: 'get',
    params: query,
  });
}
